// extracted by mini-css-extract-plugin
module.exports = {"inner":"inner___2Jqxj"};